module.exports = __webpack_public_path__ + "static/antd-datepicker-range-presets-7cf5541aca888d7799ae9715c7466840.png";